import { createRoot } from "react-dom/client";
import { App } from "./App";
import { useNavigate } from 'react-router-dom';

const container = document.getElementById("app");
const root = createRoot(container)
root.render(<App />);
